import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var MutableRangeClass;
function MutableRange() {
  if (MutableRangeClass === VOID) {
    class $ {
      constructor(start, end) {
        this.m59_1 = start;
        this.n59_1 = end;
      }
      toString() {
        return 'MutableRange(start=' + this.m59_1 + ', end=' + this.n59_1 + ')';
      }
    }
    initMetadataForClass($, 'MutableRange');
    MutableRangeClass = $;
  }
  return MutableRangeClass;
}
//region block: exports
export {
  MutableRange as MutableRange2j0kfnqv5bc35,
};
//endregion

//# sourceMappingURL=MutableRange.mjs.map
